(function() {
  function fitResume() {
    const wrapper = document.querySelector('.resume-form-wrapper');
    if (!wrapper) return;

    const formWidth = wrapper.offsetWidth;      // chiều rộng gốc (px)
    const viewportWidth = window.innerWidth;    // chiều rộng màn hình

    if (viewportWidth <= 1024) { // chỉ tablet trở xuống
      const scale = viewportWidth / formWidth;
      wrapper.style.transform = `scale(${scale})`;
      wrapper.style.transformOrigin = 'top left';
    } else {
      // reset về mặc định khi desktop
      wrapper.style.transform = '';
      wrapper.style.transformOrigin = '';
    }
  }

  window.addEventListener('load', fitResume);
  window.addEventListener('resize', fitResume);
  window.addEventListener('turbo:load', fitResume);
})();

async function downloadPDF() {
  const element = document.getElementById('resume');
  const filename = '履歴書.pdf';

  // Get the actual element dimensions
  const elementHeight = element.scrollHeight;
  const elementWidth = element.scrollWidth;

  // Detect Windows for minimal adjustment
  const isWindows = navigator.platform.indexOf('Win') > -1;

  // Configure html2pdf options for A4 size with images
  const opt = {
    margin: 12 * 1.5,
    filename: filename,
    image: {
      type: 'jpeg',
      quality: 0.98 // Slightly reduced for better performance
    },
    html2canvas: {
      scale: 2,
      useCORS: true,
      allowTaint: true,
      letterRendering: false,
      logging: true, // Enable logging to debug
      // Add extra width for Windows to capture right border
      width: elementWidth + 10
    },
    jsPDF: {
      unit: 'mm',
      format: [210 * 1.5, 297 * 1.5],
      orientation: 'portrait'
    },
    pagebreak: {
      mode: ['css', 'legacy'],
      before: '.page-break-before',
      after: '.page-break-after',
      avoid: '.page-break-avoid'
    }
  };

  try {
    document.getElementById('download-pdf').disabled = true;

    await html2pdf().from(element).set(opt).save();
  } catch (error) {
    console.error('Error downloading PDF:', error);
  } finally {
    document.getElementById('download-pdf').disabled = false;
  }
}

// Make function globally available
window.downloadPDF = downloadPDF;